import { Box, CardContent, Divider, Grid, List, Typography } from '@mui/material'
import { styled } from '@mui/system'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Carousel } from 'react-responsive-carousel'
import { INovelty } from '../../../../backoffice/novelties/models/novelties'
import CardHero from '../../../../shared/components/frontoffice/CardHero'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

const ContainerCarousel = styled('div')({
  position: 'relative'
})
const ContentFeed = {
  padding: '0px 0px 8px 0px',
  '&:last-child': {
    paddingBottom: 8
  }
}
const CustomCard = {
  boxShadow: 'none',
  backgroundColor: 'transparent'
}

interface HighlightNewsCarouselProps {
  highlightNews: INovelty[]
  cutContent: (content: string) => string
}

const HighlightNewsCarousel = ({ highlightNews, cutContent }: HighlightNewsCarouselProps) => {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  return (
    <>
      {highlightNews.length >= 2 && (
        <>
          <Box display="flex" alignItems="center" pb={2}>
            <Typography variant="h6" style={{ minWidth: 'fit-content' }}>
              {t('featured')}
            </Typography>
            <Divider style={{ marginLeft: 16, flexShrink: 1 }} />
          </Box>

          <Grid container item alignContent="flex-start" style={{ padding: '1rem' }}>
            <Grid item xs={isMobile && highlightNews.length >= 7 ? 8 : 12}>
              <ContainerCarousel>
                <Carousel centerSlidePercentage={isMobile ? 80 : 40} centerMode autoPlay showThumbs={false} interval={5000} infiniteLoop>
                  {highlightNews.map((currentNews: any) => (
                    <Box key={currentNews.id} pb={2}>
                      <CardHero
                        type={3}
                        cardBrandName={currentNews.brand?.name || ''}
                        redirect={`/noticias/${currentNews.slug}`}
                        cardVisibility={currentNews.visibility}
                        cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                        cardTitle={currentNews.title}
                      />
                    </Box>
                  ))}
                </Carousel>
              </ContainerCarousel>
            </Grid>

            {highlightNews.length >= 7 && isMobile && (
              <Grid item xs={4}>
                <Box sx={CustomCard}>
                  <CardContent sx={ContentFeed}>
                    <List component="nav">
                      {highlightNews.slice(-3).map((currentNews: any) => (
                        <Box key={currentNews.id} pb={2}>
                          <CardHero
                            type={0}
                            redirect={`/noticias/${currentNews.slug}`}
                            cardBrandName={currentNews.brand?.name || ''}
                            cardVisibility={currentNews.visibility}
                            cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                            cardTitle={currentNews.title}
                            cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(currentNews.content) }} />}
                            cardDate={`${dayjs(currentNews.created_at).fromNow()}`}
                          />
                        </Box>
                      ))}
                    </List>
                  </CardContent>
                </Box>
              </Grid>
            )}
          </Grid>
        </>
      )}
    </>
  )
}

export default HighlightNewsCarousel
